/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from 'components/Tooltip';
import Fab from '@material-ui/core/Fab';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import XGrid3 from 'components/XGrid3';
import QuickFilterSearch from 'Search/components/QuickFilterSearch';
import { getService } from 'reducers/service';
import { getContactMethods } from 'reducers/SearchReducer';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import { showContactMethod } from 'reducers/DialogsReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  fileInput: {
    display: 'none',
  },
}));
const bool = (params) => (params.value ? <CheckIcon /> : <span></span>);

const defaultColumns = [
  'ContactMethod',
  { field: 'MethodType', headerName: 'Type' },
  'Info',
  {
    field: 'IsDefault',
    headerName: 'IsDefault',
    width: 100,
    format: 'bool',
    renderCell: bool,
  },
  'Created',
  'CreatedBy',
  'Updated',
  'UpdatedBy',
];
const PlaceContact = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ptsPlaceID } = props;
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setSelection] = useState(null);
  const [columns, setColumns] = useState(defaultColumns);
  const [isDeleted, setIsDeleted] = useState(false);
  const mountedRef = useRef(true);
  const placePerms = getFullPermissions('globals', 'Places', 'any');
  const canEditPlace = Boolean(placePerms.Edit);

  const editContactMethod = useSelector((state) => state.dialogs.editContactMethod);

  useEffect(() => {
    const data = processData(props.contactInfo);
    setRows(data);
    setLoaded(true);
  }, [props.contactInfo]);

  useEffect(() => {
    ptsPlaceID && getData();
  }, [editContactMethod, isDeleted]);

  const getData = async () => {
    try {
      const data = await getContactMethods(ptsPlaceID, 'Place');
      if (!mountedRef.current) return;

      setRows(processData(data.data));
      setLoaded(true);
    } catch (err) {
      dispatch(handleError(err));
    }
  };

  const processData = (data) => {
    return data.map((row, idx) => {
      return {
        ...row,
        id: idx,
      };
    });
  };

  const add = () => {
    dispatch(showContactMethod({ ptsParentID: ptsPlaceID, PartyType: 'Place' }));
  };

  const edit = () => {
    const item = rows.find((row) => row.id === selection);
    dispatch(showContactMethod({ ...item }));
  };

  const deleteContact = async () => {
    if (!window.confirm('Are you sure you want to remove this record?')) return;
    const item = rows.find((row) => row.id === selection);
    try {
      dispatch(showSpinner());
      const service = getService('record-person-contact');
      await service.remove(item.ptsInfoID);
      setIsDeleted(!isDeleted);
    } catch (err) {
      dispatch(handleError(err));
    } finally {
      dispatch(hideSpinner());
    }
  };

  return (
    <div className={classes.wrap}>
      <div className={classes.filterWrap}>
        <div className={classes.filterWrap}>
          <QuickFilterSearch rows={rows} columns={columns} setFilteredRows={setFilteredRows} />
        </div>
        <div className={classes.actions}>
          <Tooltip title="Add Contact Method">
            <Fab size="small" color="secondary" onClick={add} disabled={!canEditPlace}>
              <AddIcon />
            </Fab>
          </Tooltip>

          {selection !== null && (
            <>
              <Tooltip title="Edit Contact Method">
                <Fab size="small" color="secondary" onClick={edit} disabled={!canEditPlace}>
                  <EditIcon />
                </Fab>
              </Tooltip>

              <Tooltip title="Download Contact Method">
                <Fab
                  size="small"
                  color="secondary"
                  onClick={deleteContact}
                  disabled={!canEditPlace}>
                  <DeleteIcon />
                </Fab>
              </Tooltip>
            </>
          )}
        </div>
      </div>
      <XGrid3
        name="PlaceContact"
        columns={columns}
        setColumns={setColumns}
        rows={filteredRows}
        loading={!loaded}
        setSelection={setSelection}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    editContactMethod: state.dialogs.editContactMethod,
  };
};

export default connect(mapStateToProps, { handleError, showSpinner, hideSpinner })(PlaceContact);
